module.exports = __webpack_public_path__ + "static/scale-model-of-washington-state-history-museum-in-tacoma-washington-ebdaf48d370a8a2b2fcc55c03f70a840.png";